import { get_question_answers } from "../../../../server/requests"
import "../Quizes.scss"



const StartQuiz = ({ configs, changeComponent, spikAllQuestion }) => {

    const icon = configs?.logo

    const start = () => changeComponent('quiz')

    return (
        <div className="quiz-main">
            <div className="quiz-context">
                <div className="quiz-logo">
                    <img src={icon} alt="" />
                </div>
                <div className="quiz-pargaraph">
                    <p>
                        IMPORTANT NOTE PLEASE READ: Before answering the next quick 7 questions please give it a thought and
                        answer them sincerely! Please don’t just quickly skip them through 🙂 because you WON’T BE ABLE
                        TO GO BACK AND CHANGE YOUR ANSWERS! Your answers will determine your entire DanceFit+ journey
                        and it will affect your placement into a correct level of difficulty to ensure the best learning experience.
                    </p>
                </div>
                <div className="functional-contex">
                    <button className="btn" onClick={start}>Start</button>
                    <button className="btn" onClick={spikAllQuestion}>Skip</button>
                </div>
            </div>
        </div>
    )
}
export default StartQuiz